import { assert } from '../lib/assert-sidecar'
import { IMachine } from './machines'
import { fullnessIndicators } from '../indicators/fullnessIndicators-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { jobCreators } from '../behavior/jobCreators-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { jobs } from '../behavior/jobs-sidecar'

import { machines } from './machines-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'water-cooler')
}

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate

  obj.fullnessIndicator = fullnessIndicators.create()

  let jc = jobCreators.create(
    () => {
      if (obj.waterSupply > 0) {
        return false
      }
      if (!cargoes.existsOfType('water')) {
        return false
      }

      return true
    },
    () => {
      let j = jobs.create('fill-water')
      j.machine = obj
      return j
    },
  )
  obj.jobCreators.push(jc)
}

export function onUpdate(obj: IMachine) {
  ensure(obj)

  if (obj.fullnessIndicator) {
    fullnessIndicators.attach(
      obj.fullnessIndicator,
      obj.image.x + 10,
      obj.image.y + 12,
      obj.waterSupply / 100,
    )
  }

  if (obj.waterSupply <= 0) {
    spriteMap.setFrame(obj.image, obj.data.frames[1])
  } else {
    spriteMap.setFrame(obj.image, obj.data.frames[0])
  }
}
